<template>
    <div>
        <CuentaAtras @tiempoTerminado="tiempoTerminado"/>
        <section class="padding-vertical-content">
            <Stepper ref="stepper" :steps="steps">
                <template #pasoSector="{ changeStep }">
                    <SeleccionarZonaComponent
                        @zonaSeleccionada="(zona) => {
                            zona_seleccionada = zona;
                            changeStep();
                        }"
                        :sga_event_id="event.sga_id"
                    />
                </template>
                <template #pasoAsiento="{ changeStep }">
                    <SeleccionarAsientosSga
                        tipo="eventos"
                        :zona="zona_seleccionada"
                        :sga_event_id="event.sga_id"
                        :event_session_id="event.sesion_id"
                        @sesionCreada="onSesionCreada"
                        @volver="() => {
                            zona_seleccionada = null;
                            eliminarDatos();
                            changeStep(true);
                        }"
                    />
                </template>
                <template #pasoDatos="{ changeStep }">
                    <DatosCompradoresSgaComponent
                        :items_carrito="items_carrito"
                        :sga_event_id="event.sga_id"
                        :datos_comprador="datos_comprador"
                        @fillDatosCompradores="updateDatosCompradores"
                        @setDatosCobro="(...args) => {
                            setDatosCobro(...args);
                            changeStep();
                        }"
                        @volver="() => {
                            eliminarDatos();
                            changeStep(true);
                        }"
                    />
                </template>
                <template #pasoResumen="{ changeStep }">
                    <ResumenCompraComponent
                        :items="items_carrito"
                        :event="event"
                        ga4-category="Entrada"
                        :jet_id="jet_id"
                        :formulario="formulario"
                        :cart_id="cart_id"
                        @setDatosCobro="setDatosCobro"
                        @terminado="() => {
                            changeStep();
                        }"
                        @volver="() => {
                            changeStep(true);
                        }"
                    />
                </template>
                <template #pasoTarjeta="{ changeStep }">
                    <ProcesarPago
                        :jet_id="jet_id"
                        :session_id="session_id"
                        @terminado="() => {
                            changeStep();
                        }"
                    />
                </template>
            </Stepper>
        </section>
    </div>
</template>
<script>
    import Stepper from '@/components/frontend/events/compra/components/Stepper.vue';
    import SeleccionarZonaComponent from '@/components/frontend/abonos/sga/SeleccionarZonaComponent.vue';
    import SeleccionarAsientosSga from '@/components/frontend/abonos/sga/SeleccionarAsientosSga.vue';
    import DatosCompradoresSgaComponent from '@/components/frontend/events/compra/sga/DatosCompradoresSgaComponent.vue';
    import ResumenCompraComponent from '@/components/frontend/components/sga/ResumenCompraComponent.vue';
    import ProcesarPago from '../../../abonos/sga/ProcesarPago.vue';
    import CuentaAtras from '@/components/frontend/events/compra/CuentaAtras';
    import { useEventoTracking } from '@/composables/front/analytics/useEventoTracking';

    export default {
        props: {
            event: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                zona_seleccionada: null,
                items_carrito: null,
                session_id: null,
                formulario: null,
                jet_id: null,
                cart_id: null,
                datos_comprador: {
                    nombre: '',
                    apellidos: '',
                    edad: '',
                    telefono: null,
                    cp: '',
                    tipo_dni: '',
                    dni: '',
                    email: '',
                    email_confirmation: '',
                    dispositivo: null
                }
            }
        },
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            teatro(){
                return this.$store.getters.getTeatro;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            steps() {
                return [
                    { label: this.$t('abonados.seleccionar_sector'), slot: 'pasoSector' },
                    { label: this.$t('abonados.seleccionar_asientos'), slot: 'pasoAsiento' },
                    { label: this.$t('abonados.rellenar_datos'), slot: 'pasoDatos' },
                    { label: this.$t('abonados.resumen'), slot: 'pasoResumen' },
                ]
            },
        },
        methods: {
            tiempoTerminado() {
                this.eliminarDatos();
                this.$refs.stepper.changeStep(false, true);
            },
            eliminarDatos() {
                if (this.cart_id) {
                    this.$store.dispatch(this.config.getVuexAlias('sga.cart.eliminar-datos'), { cart_id: this.cart_id }).then(() => {
                        Object.assign(this.datos_comprador, {
                            nombre: '',
                            apellidos: '',
                            edad: '',
                            telefono: null,
                            cp: '',
                            tipo_dni: '',
                            dni: '',
                            email: '',
                            email_confirmation: '',
                            dispositivo: null
                        })
                    }).catch(() => {
                        this.$toast.error('Error al eliminar datos')
                    });
                }
                localStorage.removeItem('sga_eventos_cart_id');
            },
            setDatosCobro(jet_id, formulario, session_id, cart_id) {
                this.jet_id = jet_id;
                this.formulario = formulario;
                this.session_id = session_id;
                this.cart_id = cart_id;
            },
            updateDatosCompradores(datos, entradas) {
                this.datos_comprador = { ...datos };

                this.items_carrito = this.items_carrito.map((item, idx) => ({
                    ...item,
                    ...entradas[idx]
                }));
            },
            onSesionCreada(items, carrito_id) {
                this.items_carrito = items;
                this.cart_id = carrito_id;

                const { trackBeginCheckout } = useEventoTracking({ store: this.$store, getVuexAlias: this.config.getVuexAlias });
                trackBeginCheckout({
                    evento_id: this.event?.id,
                    evento_name: this.event?.nombre || this.event?.name,
                    entradas: (this.items_carrito || []).map(item => ({
                        price: parseFloat(item.precio?.amount || item.price || 0),
                        unidades: item.unidades || 1
                    })),
                    productos: [],
                    total_price: (this.items_carrito || []).reduce((sum, item) => sum + ((parseFloat(item.precio?.amount || item.price || 0)) * (item.unidades || 1)), 0),
                    moneda: 'EUR'
                });

                this.$refs.stepper.changeStep();
            }
        },
        mounted() {
            this.eliminarDatos();

            if (this.teatro.tipo_tpv === 2) {
                this.steps.push({ label: 'Datos de pago', slot: 'pasoTarjeta' });
            }
        },
        components: {
            Stepper, SeleccionarZonaComponent, SeleccionarAsientosSga, DatosCompradoresSgaComponent, ResumenCompraComponent, ProcesarPago,
            CuentaAtras
        }
    }
</script>
